export enum LocationState {
    Available = 'available',
    PerhapsAvailable = 'perhaps_available',
    NotAvailable = 'not_available',
}
